import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { renderBorderShadingElementReadOnly } from './renderElementReadOnly';
import { renderBorderShadingElement } from './renderElement';

import { BorderShadingElementPluginOptions } from './types';

export const BorderShadingElementPlugin = (
  options?: BorderShadingElementPluginOptions
): SlatePlugin => {
  return {
    renderElement: options.isReadOnly
      ? renderBorderShadingElementReadOnly(options)
      : renderBorderShadingElement(options),
  };
};
